// src/utils/validators/ugc/videoMetadata.ts
export async function getVideoDurationSeconds(file: File): Promise<number> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement("video");

    const cleanup = () => {
      try {
        URL.revokeObjectURL(url);
      } catch {}
      // help GC
      video.src = "";
      video.removeAttribute("src");
      video.load();
    };

    video.preload = "metadata";
    video.muted = true;
    video.playsInline = true;

    video.onloadedmetadata = () => {
      const dur = Number(video.duration);
      cleanup();
      if (!Number.isFinite(dur) || dur <= 0) {
        reject(new Error("Invalid video duration."));
        return;
      }
      resolve(dur);
    };

    video.onerror = () => {
      cleanup();
      reject(new Error("Failed to read video metadata."));
    };

    video.src = url;
  });
}
